import { render, staticRenderFns } from "./WebsiteLandingView.vue?vue&type=template&id=07052b98"
import script from "./WebsiteLandingView.vue?vue&type=script&lang=js"
export * from "./WebsiteLandingView.vue?vue&type=script&lang=js"
import style0 from "./WebsiteLandingView.vue?vue&type=style&index=0&id=07052b98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports